module.exports = __webpack_public_path__ + "img/green_064.388bb91d.png";